import { render, staticRenderFns } from "./SharedUserOfGroupDialog.vue?vue&type=template&id=899dc272&scoped=true&"
import script from "./SharedUserOfGroupDialog.vue?vue&type=script&lang=ts&"
export * from "./SharedUserOfGroupDialog.vue?vue&type=script&lang=ts&"
import style0 from "./SharedUserOfGroupDialog.vue?vue&type=style&index=0&id=899dc272&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "899dc272",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VCardTitle,VDialog,VProgressCircular,VSpacer})
